import { useEffect, useState } from "react";
import { EmpresaSupervisora, EmpresaSupervisoraFiltro } from "../../../../types/EmpresaSupervisora";
import { useEmpresaSupervisora } from "../../../../hooks/useEmpresaSupervisora";
import FormSelectBox from "../../../../components/Form/FormSelectBox";
import { cargarCombo } from "../../../../services/Service";
import { toast } from "react-toastify";


export const BuscarEmpresaSupervisora = () => {
    const { empresaSupervisoraFiltroInitial, buscarEmpresasSupervisoras, filtro, handleFiltroEmpresaSupervisora } = useEmpresaSupervisora();
    const [filtroEmpresaSupervisora, setFiltroEmpresaSupervisora] = useState<EmpresaSupervisoraFiltro>(filtro);
    const [empresasSupervisoras, setEmpresasSupervisoras] = useState<EmpresaSupervisora[]>([]);
    const [estados] = useState<any>(
        [
            {
                'id': 'true',
                'valor': 'ACTIVA'
            },
            {
                'id': 'false',
                'valor': 'INACTIVA'
            }
        ]);

    const buscar = (filtroBusqueda: EmpresaSupervisoraFiltro) => {
        buscarEmpresasSupervisoras(filtroBusqueda)
            .catch((error: any) => {
                if (error?.response?.status === 403) {
                    toast.error('No tiene permisos para consultar Empresas Supervisoras');
                }
            });
    }

    useEffect(() => {
        cargarCombo('empresasSupervisoras/current', setEmpresasSupervisoras);
        buscar(filtroEmpresaSupervisora);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        e.preventDefault();
        setFiltroEmpresaSupervisora({
            ...filtroEmpresaSupervisora,
            [e.target.name]: e.target.value,
        });
    };

    const handleSubmit = (e: any) => {
        e.preventDefault();
        buscar(filtroEmpresaSupervisora);
        handleFiltroEmpresaSupervisora(filtroEmpresaSupervisora)
    }

    const handleClean = () => {
        setFiltroEmpresaSupervisora(empresaSupervisoraFiltroInitial);
        handleFiltroEmpresaSupervisora(empresaSupervisoraFiltroInitial);
        buscar(empresaSupervisoraFiltroInitial);
    };

    return (

        <div className="card">
            <form id="dto" className="form-horizontal" action="buscarEmpresasSupervisoras" method="post">
                <div className="card-body">
                    <h4 className="m-t-0 header-title">
                        <i className="fa fa-search margin-right-7" aria-hidden="true" style={{ marginRight: "5px" }}></i>
                        Buscar
                    </h4>
                    <hr />

                    <div className="row mt-2">

                        <FormSelectBox
                            title={'Empresa Supervisora'}
                            label={'empresa supervisora'}
                            id={'idEmpresaSupervisora'}
                            name={'idEmpresaSupervisora'}
                            onChange={handleChange}
                            optionId={'id'}
                            optionLabel={'nombreEmpresa'}
                            value={filtroEmpresaSupervisora.idEmpresaSupervisora || ''}
                            options={empresasSupervisoras}
                        />

                        <FormSelectBox
                            title={'Estado'}
                            label={'estado'}
                            id={'activo'}
                            name={'activo'}
                            onChange={handleChange}
                            optionId={'id'}
                            optionLabel={'valor'}
                            value={filtroEmpresaSupervisora.activo || ''}
                            options={estados}
                            seleccionarText="TODOS"
                        />

                    </div>

                    <hr />
                    <div className="row">
                        <div className="col-md-12 text-center">

                            <button className="btn btn-secondary btn-rounded waves-effect waves-light mr-1" type="button" id="limpiarFiltro" onClick={handleClean}>
                                <i className="fa fa-refresh mr-1" aria-hidden="true"></i>
                                Limpiar
                            </button>
                            <button className="btn btn-success btn-rounded waves-effect waves-light " type="submit" onClick={handleSubmit}>
                                <i className="fa fa-search mr-1"></i>
                                Buscar
                            </button>

                        </div>
                    </div>

                </div>
            </form>
        </div>
    )
}
